import { buildActionUrl, RIDER_ENDPOINTS, addUserIdToBody } from '../config/apiConfig'
import Storage from '@/shared/utils/storage'

export default {
  async execute(payload = { latitude: 0, longitude: 0 }) {
    try {
      const url = buildActionUrl(RIDER_ENDPOINTS.UPDATE_LOCATION)
      const body = addUserIdToBody({
        latitude: payload.latitude,
        longitude: payload.longitude,
      })

      // Get auth token from storage if needed
      const userData = Storage.get('userData')
      const token = userData?.token || userData?.accessToken || ''

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      return await response.json()
    } catch (error) {
      console.error('[updateLocation] Error:', error.message)
      throw error
    }
  },
}
